import axios from "axios";
import { setCurrentUser } from "utils/utils";
import { API_ENDPOINT } from "./Api";

const baseUrl = process.env.REACT_APP_API_BASE_URL;
let mapUrl = process.env.REACT_APP_GOOGLE_MAP_URL;
let mapKey = process.env.REACT_APP_GOOGLE_API_KEY;


const requestInstance = axios.create({
  baseURL: mapUrl,
});
export const autocompleteApi = async (data) => {
  let url = `${baseUrl}${API_ENDPOINT.GoogleMap.autocompleteApi}?name=${data?.name}&location=${data?.location}`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const nearbysearchApi = async (data) => {
  let url = `${baseUrl}${API_ENDPOINT.GoogleMap.nearbysearch}?name=${data?.name}&location=${data?.location?.lat},${data?.location?.lng}`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
}

export const placeApi = async (data) => {
  let url = `${baseUrl}${API_ENDPOINT.GoogleMap.placeApi}?placeId=${data?.place_id}`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const directionApi = async (data) => {
  let url = `${baseUrl}${API_ENDPOINT.GoogleMap.directionApi}?destLat=${data?.destination?.lat}&destLng=${data?.destination?.lng}&orgLat=${data?.origin?.lat}&orgLng=${data?.origin?.lng}`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const geocodeApi = async (data) => {
  let url = `${mapUrl}${API_ENDPOINT.GoogleMap.geocodeApi}?latlng=${data?.latlng}&key=${mapKey}`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};
